import React from 'react';
import ReactMarkdown from 'react-markdown';
import { Card, CardSegment } from '../ui';

const PrivateNoteCardSmall: React.FC<{ content: string }> = ({ content }) => (
  <div className="bt b--light-gray silver bg-near-white tl f7 serif lh-copy">
    <CardSegment className="pv3">
      <ReactMarkdown source={content} className="markdown-summary" />
    </CardSegment>
  </div>
);

const PrivateNoteCardNotSmall: React.FC<{ content: string }> = ({ content }) => (
  <Card className="silver bg-near-white tl f7 serif lh-copy mb2">
    <CardSegment className="pv4">
      <ReactMarkdown source={content} className="markdown-summary" />
    </CardSegment>
  </Card>
);

export { PrivateNoteCardSmall, PrivateNoteCardNotSmall };
